import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionCuratedClosets.module.css';

const COLUMN_CONFIG = [
  { responsiveImageSizes: '(max-width: 767px) 100vw, 1200px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 600px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 400px' },
  { responsiveImageSizes: '(max-width: 767px) 100vw, 265px' },
];
const getIndex = numColumns => numColumns - 1;
const getResponsiveImageSizes = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.responsiveImageSizes : COLUMN_CONFIG[0].responsiveImageSizes;
};

const AccentTitle = ({ data }) => {
  if (!data?.content) return null;
  const parts = data.content.split(/\*\*(.*?)\*\*/g);
  return (
    <h2 className={css.title}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={css.titleAccent}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </h2>
  );
};

const SectionCuratedClosets = props => {
  const {
    sectionId,
    className,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    secondaryCallToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      rootClassName={css.root}
      className={className}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <div className={css.headerRow}>
          <div className={css.titleCol}>
            <AccentTitle data={title} />
          </div>
          <div className={css.metaCol}>
            <Field data={description} className={css.description} options={fieldOptions} />
            <div className={css.ctaRow}>
              <Field data={callToAction} className={css.ctaButton} options={fieldOptions} />
              {secondaryCallToAction ? (
                <Field
                  data={secondaryCallToAction}
                  className={css.ctaSecondary}
                  options={fieldOptions}
                />
              ) : null}
            </div>
          </div>
        </div>
      ) : null}

      {hasBlocks ? (
        <div className={classNames(css.imagesRow, { [css.noSidePaddings]: false })}>
          {blocks.map((block, index) => {
            const id = block?.id?.uuid || block?.id || `${sectionId}-${index}`;
            const closetName = block?.title?.content || block?.title || block?.name || '';

            return (
              <div key={id} className={css.closetItem}>
                <div className={css.closetImage}>
                  <BlockBuilder
                    blocks={[block]}
                    sectionId={sectionId}
                    responsiveImageSizes={getResponsiveImageSizes(numColumns)}
                    options={options}
                  />

                  {closetName ? (
                    <div className={css.closetText}>
                      <span className={css.closetName}>{closetName}</span>
                      <span className={css.closetLink}>
                        Ver closet <span className={css.closetArrow}>→</span>
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionCuratedClosets;